// src/scenes/users/form.jsx
import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const UserForm = ({
  open,
  onClose,
  formData,
  setFormData,
  onSubmit,
  mode = "create", // "create" or "edit"
}) => {
  const isEdit = mode === "edit";

  useEffect(() => {
    // Optionally reset form on open/close toggle
    if (!open) {
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        idNumber: "",
        address: "",
        roleId: 3,
      });
    }
  }, [open, setFormData]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEdit ? "Update User" : "Create New User"}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="First Name"
          margin="dense"
          value={formData.firstName || ""}
          onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
        />
        <TextField
          fullWidth
          label="Last Name"
          margin="dense"
          value={formData.lastName || ""}
          onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
        />
        <TextField
          fullWidth
          label="Email"
          margin="dense"
          value={formData.email || ""}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        <TextField
          fullWidth
          label="Phone Number"
          margin="dense"
          value={formData.phoneNumber || ""}
          onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
        />
        <TextField
          fullWidth
          label="ID Number"
          margin="dense"
          value={formData.idNumber || ""}
          onChange={(e) => setFormData({ ...formData, idNumber: e.target.value })}
        />
        <TextField
          fullWidth
          label="Address"
          margin="dense"
          value={formData.address || ""}
          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          {isEdit ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
